import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';
import { RENOLOG_ADMIN_LOCAL_API_REQUESTS } from './constants';

export const syncAdminDevices = async () => {
  const signedRequest = await createSignedPostRequest({
    apiPath: 'legacy_admin/renolog/sync-devices',
    body: {},
    isLocalApiRequest: RENOLOG_ADMIN_LOCAL_API_REQUESTS,
  });
  const response = await axios(signedRequest);
  return response.data;
};
